import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

// Load Stripe outside of a component's render to avoid recreating the Stripe object
// For local development, use test keys
const STRIPE_PUBLISHABLE_KEY  = 'pk_test_51R2KqvH1eAwBZVET9jnMNXay7GqjNtBahWEYroofHqczuJ68X9vmSaJbZh7VJELk85j3C5JYB7fJHx0121StIYFA00tEXjXHL2'// Replace with your actual test key

const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

// Log which key we're using (for debugging)
console.log('Stripe initialized with key type:', STRIPE_PUBLISHABLE_KEY.startsWith('pk_test') ? 'TEST' : 'LIVE');

const StripeWrapper = ({ children }) => {
  return (
    <Elements stripe={stripePromise}>
      {children}
    </Elements>
  );
};

export default StripeWrapper; 